import { Chip } from '@material-ui/core';
import { STATUS_COLORS, DEFAULT_STATUS_LABEL, STATUS_COLOR_FALLBACK } from './constants';

// Case/whitespace-tolerant lookup, so a backend sending "created" or "Ongoing "
// still gets its colour instead of silently falling through to the fallback.
const STATUS_COLORS_BY_KEY = Object.keys(STATUS_COLORS).reduce((acc, key) => {
  acc[key.trim().toLowerCase()] = STATUS_COLORS[key];
  return acc;
}, {});

// A campaign/project with no status yet is displayed as "Created".
export const normalizeStatusLabel = (status) => {
  const text = status == null ? '' : String(status).trim();
  return text || DEFAULT_STATUS_LABEL;
};

export const getStatusColor = (status) => {
  const key = normalizeStatusLabel(status).toLowerCase();
  return STATUS_COLORS_BY_KEY[key] || STATUS_COLOR_FALLBACK;
};

export const renderStatusChip = (status, classes) => {
  // Label from the normalized value so an empty status renders "Created"
  // rather than a chip with no text at all.
  const label = normalizeStatusLabel(status);
  const color = getStatusColor(label);
  return (
    <Chip
      label={label}
      className={classes.statusChip}
      style={{
        backgroundColor: color,
        color: 'white',
        fontWeight: 500,
      }}
      size="small"
    />
  );
};

export const initializeBatchNumbers = (projects) => {
  const initialBatchNumbers = {};
  projects.forEach((project) => {
    if (project.cmoBatchNumber) {
      const batchNumbers = project.cmoBatchNumber.split(',').map(b => b.trim());
      if (batchNumbers.length > 0) {
        initialBatchNumbers[project.id] = batchNumbers[0];
      }
    }
  });
  return initialBatchNumbers;
};

export const initializeUnitProcedures = (projects) => {
  const initialUnitProcedures = {};
  projects.forEach((project) => {
    initialUnitProcedures[project.id] = 'All';
  });
  return initialUnitProcedures;
};

